<script setup lang="ts">
import { router, usePage } from "@inertiajs/vue3";
import { defineProps } from "vue";

import Block from "@/components/ui/atoms/Block.vue";
import Btn from "@/components/ui/atoms/Btn.vue";
import type { SubjectPack } from "@/shared/explorerTypes";
import { resolveUrl } from "@/utils/urls";
import type { InertiaSharedProps, User } from "@/shared/types";

interface Props {
  pack: SubjectPack;
  light?: boolean;
}

const page = usePage<InertiaSharedProps>();
const user = <User>page.props.user;
const props = withDefaults(defineProps<Props>(), {
  light: true,
});

const showPack = (slug: string) => {
  if (user) {
    return router.get(resolveUrl("subject_pack_show", slug));
  }

  return router.get(`${resolveUrl("pack_list")}#${props.pack.slug}`);
};


</script>

<template>
  <Block theme="dust" :class="['pack-card']" @click="showPack(pack.slug)">
    <div>
      <img :src="pack.image" alt="Pack" />
    </div>
    <div class="pack-card__text">
      <h2>{{ pack.name }}</h2>
      <ul>
        <li v-for="(point, index) in pack.key_points_list" :key="index">
          {{ point }}
        </li>
      </ul>
    </div>

    <Btn v-if="!light" theme="dark-bold" shape="round" class="sizeless">
      Más información
    </Btn>
  </Block>
</template>

<style scoped lang="scss">
@use "@/styles/settings/vars";

.pack-card {
  display: flex;
  flex-direction: column;
  gap: 1em;
  min-width: 30%;
  max-width: 30%;
  height: 100%;

  @media (width < 600px) {
    min-width: 75%;
  }

  &:hover {
    cursor: pointer;
    background-color: vars.$smoke;
  }

  img {
    border-radius: 1em;
    width: 100%;
    object-fit: cover;
    height: 200px;
  }

  &__text {
    ul {
      margin: 0;
      padding: 0 0.5em;
      list-style: none;

      li {
        position: relative;
        padding-left: 1.3em;
        margin-bottom: 0.5em;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0.2em;
          width: 0.8em;
          height: 0.8em;
          background: url("@img/icons/check.svg") no-repeat center center;
          background-size: contain;
        }
      }
    }
  }

  .btn-action {
    margin-top: auto;
  }
}
</style>
